import React, { useEffect } from "react";
import "../style/about.scss";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import about1 from "../image/about1.webp";
import about2 from "../image/about2.webp";
import about3 from "../image/about3.webp";
import about from "../image/about.webp";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />

      <div className="mx-auto mb-20 max-w-container leading-6 text-gray-600">
        <div className="my-section grid grid-cols-2 gap-10">
          <div>
            <img src={about} alt="" />
          </div>
          <div className="flex flex-col justify-center text-[14px]">
            <p>THE</p>
            <p className="text-[30px]">BEGINNING</p>
            <p>
              I embarked on my journey into the leather industry quite
              unexpectedly. It all began when I crafted a simple leather guitar
              strap for myself, driven by the desire for a personalized and
              durable accessory. The satisfaction of creating something with my
              own hands sparked an unexpected passion.
            </p>
          </div>
        </div>
        <div className="my-section grid grid-cols-2 gap-10">
          <div className="flex flex-col justify-center text-[14px]">
            <p>A COMMITMENT</p>
            <p className="text-[30px]">TO CRAFT</p>
            <p>
              Friends and fellow musicians admired the strap, prompting requests
              for custom pieces. Recognizing the potential, I decided to delve
              deeper into the craft, mastering various techniques and sourcing
              high-quality materials.
            </p>
          </div>
          <div>
            <img src={about1} alt="" />
          </div>
        </div>
        <div className="my-section grid grid-cols-2 gap-10">
          <div>
            <img src={about2} alt="" />
          </div>
          <div className="flex flex-col justify-center text-[14px]">
            <p>FAST FORWARD</p>
            <p className="text-[30px]">WHERE WE ARE TODAY</p>
            <p>
              WP is now a small-batch maker of quality leather goods built for
              the long haul. We make each piece in our small workshop in Leon,
              Mexico.
            </p>
          </div>
        </div>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default About;
